import React from 'react';

import { Box } from '@chakra-ui/react';
import { Alert, AlertDescription, AlertIcon, InfoWorkZero } from '@mesh.ai/rabbit';
import { PlainTextHeader } from 'Deer/components/HeaderComponents/PlainTextHeader';
import { getUserAccess, getUserL2Access } from 'Deer/helpers/getUserAccess';
import GoalPreferencesProvider from 'screens/admin/Objectives/GoalPreferences/context/GoalPreferencesProvider';
import { checkNewStaticDataFeaturesEnabled, checkSandboxStaticDataFeaturesEnabled } from 'utils/helpers/featureFlags';

import { CompanyFeedbackOverview } from './cards/Feedback/CompanyFeedbackOverview';
import { CompanyGoalsOverview } from './cards/Goals/CompanyGoalsOverview';
import { CompanyOneOnOneOverview } from './cards/OneOnOne/CompanyOneOnOneOverview';
import { CompanyPerformanceCheckIns } from './cards/PerformanceCheckIns/CompanyPerformanceCheckIns';
import { CompanyReviewsOverview } from './cards/Reviews/CompanyReviewsOverview';

const modules = [
  {
    check: () => getUserAccess().isReviewAdmin && getUserL2Access().hasReviewAccess,
    component: <CompanyReviewsOverview />,
  },
  {
    check: () =>
      getUserAccess().isGoalAdmin &&
      getUserL2Access().hasGoalAccess &&
      (checkSandboxStaticDataFeaturesEnabled() || checkNewStaticDataFeaturesEnabled()),
    component: <CompanyPerformanceCheckIns />,
  },
  {
    check: () => getUserAccess().isGoalAdmin && getUserL2Access().hasGoalAccess,
    component: (
      <GoalPreferencesProvider>
        <CompanyGoalsOverview />
      </GoalPreferencesProvider>
    ),
  },
  {
    check: () => getUserAccess().isFeedbackAdmin && getUserL2Access().hasIDPAccess,
    component: <CompanyFeedbackOverview />,
  },
  {
    check: () => getUserAccess().isOneOnOneAdmin && getUserL2Access().hasOneOnOneAccess,
    component: <CompanyOneOnOneOverview />,
  },
];

export const MyCompanyOverview = () => (
  <>
    <PlainTextHeader bold mb={1}>
      My company&apos;s overview
    </PlainTextHeader>
    {checkSandboxStaticDataFeaturesEnabled() || checkNewStaticDataFeaturesEnabled() ? (
      <Box mb="8px">
        <Alert variant="warning">
          <AlertIcon IconSVG={InfoWorkZero} />
          <AlertDescription>
            This is static data for demo purposes only. Any updates will not reflect on analytics.
          </AlertDescription>
        </Alert>
      </Box>
    ) : null}

    {modules?.map(
      (
        { check, component },
        index // eslint-disable-line react/no-array-index-key
      ) =>
        check() && (
          // eslint-disable-next-line react/no-array-index-key
          <Box mb={3} key={index}>
            {component}
          </Box>
        )
    )}
  </>
);
